import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { BaseCapsuleListComponent } from '@common/modules/shared/components/base-capsule-list/base-capsule-list.component';

import { IUIInsight, IUIInsightType } from '../../interfaces';
import { FocusManagerService } from '../../../accessibility/focus-manager.service';
import { TranslateHelperService } from '../../../translation/services/translate-helper.service';
import { resources } from './resources';

@Component({
  selector: 'app-vi-insights-content-list',
  // Reuse base template & styles to eliminate duplication
  templateUrl: '../../../shared/components/base-capsule-list/base-capsule-list.component.html',
  styleUrls: ['../../../shared/components/base-capsule-list/base-capsule-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InsightsContentListComponent extends BaseCapsuleListComponent<IUIInsight> implements OnInit {
  @Input() public type: IUIInsightType;

  public insightsResources = resources;
  public placeholderText = '';
  public placeholderEnterText = '';

  constructor(
    protected override focusManager: FocusManagerService,
    public override cdr: ChangeDetectorRef,
    protected override translate: TranslateHelperService
  ) {
    super(focusManager, cdr, translate);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.translate.translateResources(this.insightsResources);
    this.initPlaceholderText();
  }

  public override getItemName(item: IUIInsight): string {
    return item.name;
  }

  public override hasCustomClass(item: IUIInsight): boolean {
    return !!item.customClass;
  }

  public override getCapsuleId(item: IUIInsight): string {
    return `capsuleListItemId${item.id === -1 ? item.name : item.id}_${this.type}_${item?.appearances && item.appearances[0]?.adjustedStart}`;
  }

  public override getAnnounceText(item: IUIInsight): string {
    const itemResources = { InsightsShowingTimeline: '' };
    this.translate.translateResources(itemResources, { name: item.name });
    return itemResources.InsightsShowingTimeline;
  }

  public initPlaceholderText(): void {
    switch (this.type) {
      case 'namedEntities':
        this.placeholderText = this.insightsResources.BrandAddBrandAction;
        this.placeholderEnterText = this.insightsResources.BrandsEnterBrand;
        break;
      case 'keywords':
        this.placeholderText = this.insightsResources.KeywordAddKeyword;
        this.placeholderEnterText = this.insightsResources.KeywordsEnterKeyword;
        break;
      case 'labels':
        this.placeholderText = this.insightsResources.LabelAddLabel;
        this.placeholderEnterText = this.insightsResources.LabelsEnterLabel;
        break;
      default:
        break;
    }
  }

  protected override allowRemove(item: IUIInsight): boolean {
    return item.id > 0;
  }
}
